import React from "react";

export const SearchingLenders = () => {
    throw "Component Version Mismatch: You cannot use this config with this version of the app.";
};

export default SearchingLenders;